import { RESET_DEED_REDUCER } from "../types/deedTypes";

export const resetDeedReducer = (payload) => {
  return (dispatch) => {
    dispatch({
      type: RESET_DEED_REDUCER,
      payload: payload,
    });
  };
};
